const PartnerType = {
    LEAD: 1,
    CUSOMTER: 2,
    SUPPLIER: 3,
    CUSTOMER_SUPPLIER: 4
}

export default PartnerType;